import React, { Component, Fragment } from 'react';
import DOMPurify from 'dompurify';
import intl from 'react-intl-universal';
import Checkbox from 'src/ui/library/Checkbox';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import InfoTooltip from 'src/ui/library/ToolTip/InfoTooltip';
import iconTransform from 'src/helpers/iconTransform.js';
import ErrorIcon from '@material-ui/icons/Error';

export default class CheckboxControl extends Component {
  valueTransform = event => {
    this.props.onChange({
      target: { value: event.target.checked.toString().toLowerCase() },
    });
  };

  render() {
    const errorText = intl.get('contentparser.controlErrorMessage');
    const {
      value,
      icon,
      showText,
      align,
      label,
      increaseFontSize,
      helpText,
      lockAfterValueChange,
      readOnly,
      hasError,
      required,
      description,
      hasParentTable,
      tile,
    } = this.props;
    let labelText = transformDisplayText(label, DEFAULT_CONTROL_FONT_SIZES.CheckBox, increaseFontSize);

    if (label && helpText) {
      labelText = <InfoTooltip toolTipText={helpText} labelText={labelText} inlineLabel />;
    }

    const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';

    const type = hasError ? 'error' : '';
    let finalText = '';
    finalText = transformDisplayText(description, DEFAULT_CONTROL_FONT_SIZES[this.props.origControlTypeName], this.props.increaseFontSize);
    finalText = showText === true ? finalText : '';

    return (
      <Fragment>
        <div className={`control-text flex-column ${alignClass}`}>
          {finalText && !hasParentTable ? (
            <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
              {icon && <div className={'control-icons control-icons-inline'}></div>}
              <div className={'control-icons-inline-controls fullWidth label-field'}>
                <span component="legend" className="control-label">
                  {finalText}
                </span>
              </div>
            </div>
          ) : null}

          {/* {description && !hasParentTable && (<span className="control-label">{finalText}</span>)} */}
          {
            <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
              {tile === false && icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
              <div className={'control-icons-inline-controls fullWidth  label-field'}>
                {
                  <Fragment>
                    <Checkbox
                      checked={value || false}
                      onChange={this.valueTransform}
                      label={labelText}
                      lockAfterValueChange={lockAfterValueChange}
                      readOnly={readOnly}
                      hasError={hasError}
                      styleType={type}
                      required={required}
                      icon={icon}
                      tile={tile}
                    />
                    {hasError && (
                      <p className="textfield-error-text"> <ErrorIcon sx={{ verticalAlign:'bottom', fontSize: 14 }}/> <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errorText) }} /></p>
                    )}
                  </Fragment>
                }
              </div>
            </div>
          }
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/library/ContentParser/controls/CheckboxControl/index.js